// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cms-block',
    // #endregion
    // #region Properties
    props: {
        content: {
            type: Object,
            required: true,
            default: {}
        },
    },
    computed: {
        getComponent() {
            return this.content.type;
        }
    }
    // #endregion
});
// #endregion
